// This file includes polyfills needed by Angular and is loaded before
// the app. You can add your own extra polyfills to this file.
import 'core-js/es/symbol';
import 'core-js/es/object';
import 'core-js/es/function';
import 'core-js/es/parse-int';
import 'core-js/es/parse-float';
import 'core-js/es/number';
import 'core-js/es/math';
import 'core-js/es/string';
import 'core-js/es/date';
import 'core-js/es/array';
import 'core-js/es/regexp';
import 'core-js/es/map';
import 'core-js/es/set';
import 'core-js/es/reflect';
import '@angular/localize/init';

import 'core-js/es/reflect';
import 'zone.js';

// Promise.try — must be installed AFTER zone.js, which swaps the global Promise
// for ZoneAwarePromise and does not carry the static `try` over. pdfjs-dist v5
// (used by @mtm/media-studio's PDF player) calls
// `Promise.try(action, data.data, streamSink)`, so the polyfill has to forward
// its arguments; an arity-0 version makes every PDF preview fail with
// "Cannot set properties of undefined (setting 'onPull')".
//
// @mtm/media-studio ships its own guarded polyfill, so this only takes effect
// while that one is arity-0; the guard there is a `typeof` check, which this
// satisfies first. Keep until every consumed @mtm/media-studio build has the
// variadic version, then drop.
if (typeof (Promise as unknown as { try?: unknown }).try !== 'function') {
  (Promise as any).try = function <T>(
    fn: (...args: unknown[]) => T | PromiseLike<T>,
    ...args: unknown[]
  ): Promise<T> {
    return new Promise<T>((resolve) => resolve(fn(...args)));
  };
}

(window as any).global = window;
(window as any).process = {
  env: { DEBUG: undefined },
};
